// Frontend/src/unicodex_ui/services/portalLogisticsApi.js
import api from "./apiClient";

function cleanParams(params = {}) {
  // Drop undefined/null/"" so Axios doesn't serialize them into querystring
  const out = {};
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[k] = v;
  });
  return out;
}

const portalLogisticsApi = {
  async listShipments(params = {}) {
    const res = await api.get("/api/logistics/shipments", { params: cleanParams(params) });
    return res.data;
  },

  async getShipment(id) {
    const res = await api.get(`/api/logistics/shipments/${id}`);
    return res.data;
  },

  async createShipment(payload) {
    const res = await api.post("/api/logistics/shipments", payload);
    return res.data;
  },

    /**
   * Status-change requests must hit the dedicated endpoints (ship/arrive/receive/cancel).
   * The /events endpoint only accepts NOTE/DELAY and will return validation_error for SHIP_REQUESTED etc.
   */
  async requestAction(shipmentId, action, { note, notes, locationText, payload, meta } = {}) {
    const a = String(action || "").toUpperCase();

    const endpointMap = {
      SHIP: "ship",
      ARRIVE: "arrive",
      RECEIVE: "receive",
      CANCEL: "cancel",
    };

    const endpoint = endpointMap[a];
    if (!endpoint) throw new Error(`Unsupported action: ${action}`);

    const body = {
      locationText: locationText || "",
      // backend expects "notes" (not "note")
      notes: (notes ?? note ?? "").toString(),
      meta: meta ?? (payload?.meta ?? null),
      ...(payload || {}),
    };

    const res = await api.post(`/api/logistics/shipments/${shipmentId}/${endpoint}`, body);
    return res.data;
  },


    async addNote(shipmentId, { note, notes, locationText } = {}) {
    const body = {
      eventType: "NOTE",
      event_type: "NOTE",
      // backend schema uses "notes"
      notes: (notes ?? note ?? "").toString(),
      locationText: locationText || "",
      meta: null,
    };
    const res = await api.post(`/api/logistics/shipments/${shipmentId}/events`, body);
    return res.data;
  },

  // These are inventory helpers so the shipper can pick valid branches/locations
  async listBranches() {
    const res = await api.get("/api/inventory/branches");
    return res.data;
  },

  async listLocations(params = {}) {
    const res = await api.get("/api/inventory/locations", { params: cleanParams(params) });
    return res.data;
  },
};

export default portalLogisticsApi;
